type FieldValues = Record<string, any>;
type WorkbookColumnBuilders =
  | Record<string, (fieldValues: FieldValues) => any>
  | Array<{ columnName: string; builder: (fieldValues: FieldValues) => any }>;
type WorkbookColumns = Record<string, any>;

export const mapFieldsToWorkbookColumns = <
  TFieldValues extends FieldValues,
  TWorkbookColumnBuilders extends WorkbookColumnBuilders
>(
  fieldValues: TFieldValues,
  workbookColumnBuilders: TWorkbookColumnBuilders
) => {
  // Handle array format (preserves exact column order)
  if (Array.isArray(workbookColumnBuilders)) {
    return workbookColumnBuilders.reduce((workbook, { columnName, builder }) => {
      workbook[columnName] = builder(fieldValues);
      return workbook;
    }, {} as WorkbookColumns);
  }

  // Handle object format (legacy)
  return Object.entries(workbookColumnBuilders).reduce((workbook, entry) => {
    const [key, func] = entry;
    const workbookValue = func(fieldValues);

    workbook[key] = workbookValue;

    return workbook;
  }, {} as WorkbookColumns);
};
